<mat-progress-bar mode="indeterminate" *ngIf="!loaded"></mat-progress-bar>

<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">

    <ng-container matColumnDef="COD_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cod.</th>
      <td mat-cell *matCellDef="let element">{{element.COD_CF }}</td>
    </ng-container>

    <ng-container matColumnDef="RAG_SOC_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ragione Sociale</th>
      <td mat-cell *matCellDef="let element">{{element.RAG_SOC_CF }}</td>
    </ng-container>    

    <ng-container matColumnDef="P_IVA_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>P. IVA</th>
      <td mat-cell *matCellDef="let element">{{element.P_IVA_CF }}</td>
    </ng-container>

    <ng-container matColumnDef="COMUNE_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Comune</th>
      <td mat-cell *matCellDef="let element">{{element.COMUNE_CF }} ({{element.PROVINCIA_CF }})</td>
    </ng-container>

    <ng-container matColumnDef="TEL_CF">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contatti</th>
      <td mat-cell *matCellDef="let element">
        {{element.TEL_CF }}
        {{element.E_MAIL_CF }}
      </td>
    </ng-container>


    <!-- Filter per DOC_ID -->

    <ng-container matColumnDef="COD_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'COD_CF')" placeholder="Cod. Cli." class="form-control form-control-sm" />
      </th>
    </ng-container> 

    <ng-container matColumnDef="RAG_SOC_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'RAG_SOC_CF')" placeholder="Ragione Sociale" class="form-control form-control-sm" />
      </th>
    </ng-container>    

    <ng-container matColumnDef="P_IVA_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'P_IVA_CF')" placeholder="Partita Iva" class="form-control form-control-sm" />
      </th>
    </ng-container> 

    <ng-container matColumnDef="COMUNE_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
        <input type="text" (input)="filterchanged($event, 'COMUNE_CF')" placeholder="Comune" class="form-control form-control-sm" />
      </th>
    </ng-container> 

    <ng-container matColumnDef="TEL_CF-filter">
      <th mat-header-cell *matHeaderCellDef>
      </th>
    </ng-container> 

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>    

    <!-- Filter Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumnFilters"></tr>

    <!-- Data Rows -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>

  <mat-paginator #paginator showFirstLastButtons [length]="totalCount" [pageIndex]="currentPage" [pageSize]="perPage"
    [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
  </mat-paginator>
</div>